import React from 'react';
import { useMoneyFormat } from '../../context/LocaleContext';
import { scanNoticeText } from '../../domain/expenseForms';
import s from './ScanNotice.module.css';

// What the OCR service made of the receipt, and how much of it to trust — the
// sentence is the core's (`scan_notice`), with the doubtful fields
// (`scanUncertainties`) and the tax in the studio's money.
export default function ScanNotice({ scan }) {
  const formatMoney = useMoneyFormat();
  if (!scan || scan.error) return null;

  return (
    <div className={scan.needsReview ? s.review : s.ok}>
      {scanNoticeText(scan, scan.taxMinor != null ? formatMoney(scan.taxMinor) : null)}
    </div>
  );
}
